import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import RouteFallback from "@/sot/primitives/RouteFallback.jsx";
import { acceptInstitutionScopedMemberInvitation } from "./institutionService.js";

export default function InstitutionScopedInvitationAccept() {
  const [params] = useSearchParams();
  const invitationId = String(params.get("invitation") || "").trim();
  const [state, setState] = useState("ready");
  const [message, setMessage] = useState("");

  const accept = async () => {
    if (!invitationId) return;
    setState("pending");
    setMessage("");
    try {
      await acceptInstitutionScopedMemberInvitation({ invitationId });
      setState("accepted");
    } catch (error) {
      setState("error");
      setMessage(error?.message || "This Institution invitation could not be accepted.");
    }
  };

  if (!invitationId) return <RouteFallback label="This Institution invitation link is incomplete." />;

  return (
    <main className="institutions-loading-surface" aria-labelledby="institution-scoped-invitation-title">
      <section className="medical-institution-error" style={{ maxWidth: 640 }}>
        <h1 id="institution-scoped-invitation-title">Institution invitation</h1>
        {state === "accepted" ? (
          <>
            <p>Your Institution membership is active. It does not grant facility, programme, surveillance, clinical, or Regional Health authority.</p>
            <Link className="institutions-primary-button" to="/institutions/dashboard">Open Institution workspace</Link>
          </>
        ) : (
          <>
            <p>Accepting this invitation creates Institution membership only. A responsible administrator must separately assign any facility, programme and approved authority role.</p>
            {state === "error" ? <p role="alert">{message}</p> : null}
            <button type="button" className="institutions-primary-button" onClick={accept} disabled={state === "pending"}>{state === "pending" ? "Accepting…" : "Accept invitation"}</button>
          </>
        )}
      </section>
    </main>
  );
}
